import authReducer from './auth/authReducer';
import { combineReducers } from 'redux';
import userReducer from './user/userReducer';
import cmsReducer from './cms/cmsReducer';
import loaderReducer from './loader/loaderReducer';
import notificationReducer from "./Notifications/notificationReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  cms: cmsReducer,
  notifications: notificationReducer,
  loading: loaderReducer
});

export default rootReducer;
